import LegalLayout from './LegalLayout';
import Seo from '../components/Seo';

export default function AccountDeletion() {
  return (
    <LegalLayout title="Hesap ve Veri Silme">
      <Seo
        title="Hesap ve Veri Silme | Mahallebi"
        description="Mahallebi hesabınızı ve kişisel verilerinizi nasıl sileceğinizi adım adım anlatan rehber."
        path="/account-deletion"
      />
      <p className="text-sm text-gray-500 mb-8">
        Son güncelleme: 18 Nisan 2026
      </p>

      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#111827] mb-4">Mahallebi Hesabınızı Nasıl Silersiniz?</h2>
        <p className="mb-4">
          Mahallebi kullanıcı verileri ve hesabınızı silmek isterseniz aşağıdaki yöntemlerden birini seçebilirsiniz:
        </p>

        <h3 className="text-lg font-semibold text-[#111827] mt-6 mb-3">Yöntem 1: Uygulama İçinden Silme</h3>
        <ol className="list-decimal list-inside space-y-2 mb-4">
          <li>Mahallebi uygulamasını açın.</li>
          <li>Hesabınızla giriş yapın.</li>
          <li>Sağ alt köşedeki <strong>Profil</strong> sekmesine dokunun.</li>
          <li>Sağ üstteki <strong>⚙️ Ayarlar</strong> ikonuna dokunun.</li>
          <li><strong>Gizlilik Ayarları</strong>'na girin.</li>
          <li>Sayfanın altındaki <strong>Hesabı Sil</strong> butonuna dokunun.</li>
          <li>Onay ekranında <strong>Hesabımı Sil</strong>'i onaylayın.</li>
          <li>Hesabınız ve tüm ilişkili verileriniz 30 gün içinde kalıcı olarak silinir.</li>
        </ol>

        <h3 className="text-lg font-semibold text-[#111827] mt-6 mb-3">Yöntem 2: E-posta ile Talep</h3>
        <p className="mb-4">
          Uygulamaya erişiminiz yoksa veya hesap silme butonu çalışmıyorsa, aşağıdaki adrese e-posta göndererek hesap silme talebinde bulunabilirsiniz:
        </p>
        <p className="mb-4">
          <strong>E-posta:</strong>{' '}
          <a href="mailto:destek@mahallebi.com?subject=Hesap%20Silme%20Talebi" className="text-[#e77e23] hover:underline">
            destek@mahallebi.com
          </a>
        </p>
        <p className="mb-4">E-postanızda şu bilgileri belirtin:</p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>Kayıtlı e-posta adresiniz veya telefon numaranız</li>
          <li>Konu başlığı: <em>"Hesap Silme Talebi"</em></li>
          <li>Mesaj: Hesabınızın silinmesini talep ettiğinizi açıkça belirtin.</li>
        </ul>
        <p>Talepler 7 iş günü içinde işleme alınır.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#111827] mb-4">Silinecek Veriler</h2>
        <p className="mb-4">Hesap silme talebiniz onaylandığında aşağıdaki veriler kalıcı olarak silinir:</p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>Profil bilgileri (ad, kullanıcı adı, bio, profil fotoğrafı, güven puanı, rozetler)</li>
          <li>E-posta ve telefon numarası</li>
          <li>Konum bilgileri (mahalle, ilçe, koordinat)</li>
          <li>Oluşturduğunuz tüm ilanlar (ürün, hizmet, talep, duyuru)</li>
          <li>İşletme hesabınız (varsa) ve ilişkili vitrin</li>
          <li>Mesajlarınız (1-1 sohbetler, mesaj içerikleri)</li>
          <li>Acil yardım talepleriniz</li>
          <li>Beğenileriniz, kaydettikleriniz, takip ilişkileriniz</li>
          <li>Değerlendirmeleriniz ve yorumlarınız</li>
          <li>Uygulama bildirim geçmişiniz</li>
          <li>Push bildirim token'ı</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#111827] mb-4">Saklanan Veriler</h2>
        <p className="mb-4">
          Yasal yükümlülükler veya meşru menfaatler nedeniyle aşağıdaki veriler sınırlı bir süre boyunca saklanabilir:
        </p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li><strong>Moderasyon kayıtları:</strong> Güvenlik ve yasal uyum için 1 yıl (spam/fraud incelemesi)</li>
          <li><strong>Anonimleştirilmiş analiz verileri:</strong> Kişisel olmayan, toplu istatistikler (süresiz)</li>
          <li><strong>Yasal yükümlülük kapsamındaki loglar:</strong> Türk Ticaret Kanunu ve KVKK çerçevesinde gerekli süre</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#111827] mb-4">Ek Saklama Süreleri</h2>
        <p className="mb-4">
          Hesap silindikten sonra:
        </p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>Kişisel verileriniz <strong>30 gün içinde</strong> veritabanımızdan kalıcı olarak silinir.</li>
          <li>Yedekleme sistemlerimizden <strong>90 gün içinde</strong> temizlenir.</li>
          <li>Moderasyon kayıtları <strong>1 yıl</strong> sonra anonimleştirilir.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold text-[#111827] mb-4">Hesap Silmeden Veri Silme</h2>
        <p className="mb-4">
          Hesabınızı kapatmadan sadece belirli verilerinizi silmek isterseniz uygulama içindeki
          <strong> Gizlilik Ayarları</strong>'ndan veya <a href="mailto:destek@mahallebi.com" className="text-[#e77e23] hover:underline">destek@mahallebi.com</a> adresine yazabilirsiniz.
          Örneğin:
        </p>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>Mesaj geçmişi</li>
          <li>İlan arşivi</li>
          <li>Konum verileri</li>
          <li>Takip ilişkileri</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-[#111827] mb-4">İletişim</h2>
        <p className="mb-2">
          Hesap silme veya veri yönetimi ile ilgili sorularınız için:
        </p>
        <p>
          <strong>E-posta:</strong>{' '}
          <a href="mailto:destek@mahallebi.com" className="text-[#e77e23] hover:underline">
            destek@mahallebi.com
          </a>
        </p>
        <p className="mt-2">
          <strong>Geliştirici:</strong> UBS Bilişim
        </p>
      </section>
    </LegalLayout>
  );
}
